import React from 'react'

const CoveredText = ({ children }) => (
  <div className="covered-text">{children}</div>
)

export default CoveredText
